import IncomeReports from './income-reports';
import Invoices from './invoices';
import MonthlyStatements from './mothly-statements';
import Payouts from './payouts';
import SalesSummary from './sales-summary';
import Subscription from './subscription';

export default {
  IncomeReports,
  Invoices,
  MonthlyStatements,
  Payouts,
  SalesSummary,
  Subscription,
};
